(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    const switcher = document.querySelector('.cgv-switcher');
    const grid = document.getElementById('product-grid');
    if (!switcher || !grid) return;

    // capture the original Dawn column classes set from section settings
    // e.g. "grid--2-col-tablet-down" and "grid--4-col-desktop"
    const originalClasses = Array.from(grid.classList).filter((c) =>
      /^grid--\d+-col-(tablet-down|desktop)$/.test(c)
    );
    const tabletClass = originalClasses.find((c) => c.includes('tablet-down'));
    const desktopClass = originalClasses.find((c) => c.includes('desktop') && !c.includes('tablet'));

    function applyView(view) {
      if (view === 'list') {
        if (tabletClass) grid.classList.remove(tabletClass);
        if (desktopClass) grid.classList.remove(desktopClass);
        grid.classList.add('grid--1-col-tablet-down', 'grid--1-col-desktop');
      } else {
        grid.classList.remove('grid--1-col-tablet-down', 'grid--1-col-desktop');
        if (tabletClass) grid.classList.add(tabletClass);
        if (desktopClass) grid.classList.add(desktopClass);
      }

      switcher.querySelectorAll('.cgv-btn').forEach((btn) => {
        const isActive = btn.dataset.view === view;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive);
      });

      try {
        localStorage.setItem('cgv-view', view);
      } catch (e) {}
    }

    switcher.addEventListener('click', (e) => {
      const btn = e.target.closest('.cgv-btn');
      if (!btn) return;
      applyView(btn.dataset.view);
    });

    let saved = 'grid';
    try {
      saved = localStorage.getItem('cgv-view') || 'grid';
    } catch (e) {}
    applyView(saved);

    // reapply after facets.js / Globo re-renders #product-grid
    const gridParent = grid.parentElement;
    if (gridParent) {
      const observer = new MutationObserver((mutations) => {
        // only reapply if #product-grid itself was replaced
        if (!document.getElementById('product-grid')) return;
        let currentSaved = 'grid';
        try {
          currentSaved = localStorage.getItem('cgv-view') || 'grid';
        } catch (e) {}
        applyView(currentSaved);
      });
      observer.observe(gridParent, { childList: true, subtree: true });
    }
  }
})();